import { type Action, combineReducers } from '@reduxjs/toolkit';
import AppSlice from '../user-management/appSlice';
import VesselsLastSignalSlice from '../features/main-map/slices/vesselsLastSignalSlice';
import VesselLastVoyagesSlice from '../features/main-map/slices/vesselLastVoyagesSlice';
import VesselLastStoppageEventsSlice from '../features/main-map/slices/vesselLastStoppageEventsSlice';
import VesselLastPortCallsSlice from '../features/main-map/slices/vesselLastPortCallsSlice';
import VesselOngoingVoyageSignalsSlice from '../features/main-map/slices/vesselOngoingVoyageSignalsSlice';
import VesselVoyageDailySignalsSlice from '../features/main-map/slices/vesselVoyageDailySignalsSlice';
import VesselDailyPositionsSlice from '../features/main-map/slices/vesselDailyPositionsSlice';
import VesselOngoingVoyageDailySignalsSlice from '../features/main-map/slices/vesselOngoingVoyageDailySignalsSlice';
import SearchSlice from '../features/search/searchSlice';
import PortSlice from '../features/port/portSlice';
import ValueSlice from '../features/value/valueSlice';
import PortfolioSlice from '../features/portfolio/portfolioSlice';
import FilterSlice from '../features/filter/filterSlice';
import DcfSlice from '../features/dcf/dcfSlice';
import KpiSlice from '../features/kpis/kpiSlice';
import GreenSlice from '../features/green/greenSlice';
import DefaultActivityDateRangeSlice from '../features/main-map/slices/defaultActivityDateRangeSlice';
import FeatureDateRangeSlice from '../features/date-range/slices/dateRangeSlice';
import DetailedPolygonsSlice from '../features/main-map/slices/detailedPolygonsSlice';
import GeneralSeaAreasSlice from '../features/download/slices/generalSeaAreasSlice';
import ActivityReportSlice from '../features/download/slices/activityReportSlice';
import ColumnMappingsSlice from '../features/download/slices/columnMappingsSlice';
import AreaSignalStatisticsSlice from '../features/download/slices/areaSignalStatisticsSlice';
import VesselCurrentStatusSlice from '../features/main-map/slices/vesselCurrentStatusSlice';
import PortCallsReportSlice from '../features/download/slices/portCallsReportSlice';
import StoppageEventsReportSlice from '../features/download/slices/stoppageEventsReportSlice';
import VoyagesReportSlice from '../features/download/slices/voyagesReportSlice';
import PageContextSlice from '../routing/pageContextSlice';
import CohortSourceSlice from '../features/common/cohort/cohortSourceSlice';

const appReducer = combineReducers({
	appSlice: AppSlice,
	vesselsLastSignalSlice: VesselsLastSignalSlice,
	vesselLastVoyagesSlice: VesselLastVoyagesSlice,
	vesselLastStoppageEventsSlice: VesselLastStoppageEventsSlice,
	vesselLastPortCallsSlice: VesselLastPortCallsSlice,
	vesselOngoingVoyageSignalsSlice: VesselOngoingVoyageSignalsSlice,
	vesselVoyageDailySignalsSlice: VesselVoyageDailySignalsSlice,
	vesselDailyPositionsSlice: VesselDailyPositionsSlice,
	vesselOngoingVoyageDailySignalsSlice: VesselOngoingVoyageDailySignalsSlice,
	searchSlice: SearchSlice,
	portSlice: PortSlice,
	valueSlice: ValueSlice,
	portfolioSlice: PortfolioSlice,
	filterSlice: FilterSlice,
	dcfSlice: DcfSlice,
	kpiSlice: KpiSlice,
	greenSlice: GreenSlice,
	defaultActivityDateRangeSlice: DefaultActivityDateRangeSlice,
	featureDateRangeSlice: FeatureDateRangeSlice,
	detailedPolygonsSlice: DetailedPolygonsSlice,
	generalSeaAreasSlice: GeneralSeaAreasSlice,
	activityReportSlice: ActivityReportSlice,
	columnMappingsSlice: ColumnMappingsSlice,
	areaSignalStatisticsSlice: AreaSignalStatisticsSlice,
	vesselCurrentStatusSlice: VesselCurrentStatusSlice,
	portCallsReportSlice: PortCallsReportSlice,
	stoppageEventsReportSlice: StoppageEventsReportSlice,
	voyagesReportSlice: VoyagesReportSlice,
	pageContextSlice: PageContextSlice,
	cohortSourceSlice: CohortSourceSlice,
});

/**
 * rootReducer is the main reducer for the application.
 * It's responsible for combining the reducers returned by combineReducers
 * into a single reducer function.
 *
 * @param state The state of the application
 * @param action The action to be handled
 * @returns The new state of the application
 */
const rootReducer = (state: any, action: Action): ReturnType<typeof appReducer> => {
	return appReducer(state, action);
};

export default rootReducer;
